import { DiceObservable } from './dice';

const BOARD_WIDTH = 1626;
const BOARD_HEIGHT = 1242;
const Y_OFFSET_HEIGHT = 493;
const DROP_ZONE_WIDTH = 138;

const DICE_SPRITE_WIDTH = 200;
const DICE_SPRITE_HEIGHT = 600;
const FRAMES_PER_SECOND = 24;
const DICE_LAST_FRAME = 24;
const DICE_HEIGHT_TO_WIDTH_RATIO = DICE_SPRITE_HEIGHT / DICE_SPRITE_WIDTH;
const DICE_CONSUMED_FRAME = DICE_LAST_FRAME + 1;
const DICE_HALF_CONSUMED_FRAME = DICE_CONSUMED_FRAME + 1;

const DICE_SIZE_MULTIPLICATION = 1.3;

//Расчет соотношений в процентах
// Игровая часть доски от всей доски
const PLAY_AREA = ((BOARD_WIDTH - DROP_ZONE_WIDTH) / BOARD_WIDTH) * 100;
// Отступ сверху для отрисовки кубиков
const Y_OFFSET = (Y_OFFSET_HEIGHT / BOARD_HEIGHT) * 100;

class SingleDiceView {
  image: HTMLImageElement;
  xOffset = 0;
  yOffset = 0;
  diceWidth = 0;
  diceHeight = 0;
  pips = 0;
  frame = 0;

  constructor(image: HTMLImageElement) {
    this.image = image;
  }

  render(context: CanvasRenderingContext2D) {
    if (!this.image) return;
    context.drawImage(
      this.image,
      (this.pips - 1) * DICE_SPRITE_WIDTH,
      this.frame * DICE_SPRITE_HEIGHT,
      DICE_SPRITE_WIDTH,
      DICE_SPRITE_HEIGHT,
      this.xOffset,
      this.yOffset,
      this.diceWidth * DICE_SIZE_MULTIPLICATION,
      this.diceHeight * DICE_SIZE_MULTIPLICATION
    );
  }
}
export default class DiceView {
  rolling = false;
  dice: SingleDiceView[] = [];
  rotation = 0;

  constructor(dice1: HTMLImageElement, dice2: HTMLImageElement) {
    this.dice.push(new SingleDiceView(dice1));
    this.dice.push(new SingleDiceView(dice2));
  }

  roll(pips: [number, number]) {
    this.setPips(pips);
    this.forDice((d) => (d.frame = 0));
    this.rolling = true;
  }

  move(dice: DiceObservable) {
    this.setPips([dice.firstValue, dice.secondValue]);
    if (dice.availableMoves.length + dice.consumedMoves.length === 4) {
      switch (dice.consumedMoves.length) {
        case 0:
          this.forDice((d) => (d.frame = DICE_LAST_FRAME));
          break;
        case 1:
          this.dice[0].frame = DICE_HALF_CONSUMED_FRAME;
          break;
        case 2:
          this.dice[0].frame = DICE_CONSUMED_FRAME;
          break;
        case 3:
          this.dice[0].frame = DICE_CONSUMED_FRAME;
          this.dice[1].frame = DICE_HALF_CONSUMED_FRAME;
          break;
        case 4:
          this.forDice((d) => (d.frame = DICE_CONSUMED_FRAME));
          break;
      }
    } else {
      this.forDice((d) => {
        d.frame = dice.consumedMoves.includes(d.pips) ? DICE_CONSUMED_FRAME : DICE_LAST_FRAME;
      });
    }
  }

  recalculateSize(canvas: HTMLCanvasElement) {
    const boardWidth = (canvas.width / 100) * PLAY_AREA;
    const halfBoard = boardWidth / 2;
    this.forDice((dice) => {
      dice.xOffset = Math.floor(halfBoard / 5);
      dice.yOffset = Math.floor((canvas.height / 100) * Y_OFFSET);
      dice.diceWidth = Math.floor(halfBoard / 5) * 2;
      dice.diceHeight = dice.diceWidth * DICE_HEIGHT_TO_WIDTH_RATIO;
    });
    this.dice[1].xOffset = this.dice[1].xOffset * 2;
  }

  render(context: CanvasRenderingContext2D) {
    this.forDice((dice) => dice.render(context));

    if (this.rolling && this.dice[0].frame < FRAMES_PER_SECOND) {
      this.forDice((dice) => dice.frame++);
    } else {
      this.rolling = false;
    }
  }

  forDice(callback: (dice: SingleDiceView, index: number) => void) {
    this.dice.forEach(callback);
  }

  setPips(pips: [number, number]) {
    this.forDice((dice, index) => (dice.pips = pips[index]));
  }
}
